import globalStore from '$$globalStore';
import rights from '../../../../components/rights';

export default {
  updateButtonsInTasks(ganttInstance, ids = []) {
    const taskIds = [...new Set(ids)];
    const newTasks = [];

    taskIds.forEach(taskId => {
      const task = ganttInstance.getTask(taskId);
      const children = ganttInstance.getChildren(taskId);

      children.forEach(childId => {
        if (ganttInstance.isTaskExists(childId) && ganttInstance.getTask(childId).type === ganttInstance.config.types.button) {
          ganttInstance.silent(() => {
            ganttInstance.deleteTask(childId);
          });
        }
      });

      // multiview main parent
      if (ganttInstance.config.multiview && task.id === 1) return;

      const taskChildren = ganttInstance.getChildren(task.id);

      if (taskChildren.length && task.type === ganttInstance.config.types.project && rights.project.hasRight(task.gantt_id, 'create_task')) {
        newTasks.push({
          id: `${task.id}_buttons`,
          unscheduled: true,
          auto_scheduling: false,
          type: ganttInstance.config.types.button,
          gantt_id: task.gantt_id,
          parent: task.id,
          order: taskChildren.length + 1,
          hide_bar: true,
        });
      }
    });

    ganttInstance.silent(() => {
      ganttInstance._ganttPreventFilter = true;
      ganttInstance.parse({ data: newTasks, links: [] }, 'json');
    });
  },

  clearAndParse(ganttInstance, restoreScrollState = false) {
    const tasks = globalStore.getters['tasksModel/getTasksForGantt'](ganttInstance.config.gantt_id);
    const oldScrollState = ganttInstance.getScrollState();

    ganttInstance.ext.inlineEditors.hide();

    ganttInstance.silent(() => {
      ganttInstance._ganttPreventFilter = true;
      ganttInstance.getDatastore('task').clearAll();
      ganttInstance.getDatastore('link').clearAll();
      ganttInstance.parse(tasks);
    });

    const projectTasks = ganttInstance.getTaskBy(task => task.type === ganttInstance.config.types.project);

    this.updateButtonsInTasks(ganttInstance, projectTasks.map(task => task.id));

    ganttInstance.$layout.resize();

    if (restoreScrollState) {
      ganttInstance.scrollTo(oldScrollState.x, oldScrollState.y);
    }
  },
};
